import React from 'react';

function CallUsButton() {

  const handleOnClick = () => {
    window.open(`tel:+447936885460}`, '_self');
  }

  return (
    <div className="flex-col h-full mx-auto lg:mx-0">
      <button className="border-2 border-navy px-6 py-6 mt-10 rounded hover:bg-navy transition-all hover:text-white" onClick={handleOnClick}>
        <h2 className="text-center text-navy text-3xl font-display font-bold mb-3">Call us</h2>
        <h3 className="text-center text-accent text-2xl font-semibold">+44 7936 885460</h3>
      </button>
    </div>
  )
}

export default CallUsButton;
